module.exports = __webpack_public_path__ + "img/UHF-PS1.8462b9f3.webp";